import { getRoleDisplayName } from '@/globals/typescript/utils/roleUtils'
import { LabCustomerUserInsurance as _LabCustomerUserInsurance } from '@team-milva/lab-models/user'

/** An insurance customer's customer-app user (MIL-402). Mirrors the local `LabCustomerUserBusiness`. */
export class LabCustomerUserInsurance extends _LabCustomerUserInsurance {
  constructor(params: Partial<_LabCustomerUserInsurance> = {}) {
    super(params)
  }

  get mainRoleDisplayName(): string {
    return getRoleDisplayName(this.mainRole)
  }
}
